module.exports = __webpack_public_path__ + "img/selected.9d892c39.png";